var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7997 2.22743C17.4362 0.590855 20.0876 0.590855 21.7242 2.22743C23.3608 3.86401 23.3608 6.51551 21.7242 8.15209L9.6375 20.2387C9.50146 20.3747 9.33061 20.4707 9.14366 20.5162L5.5607 21.3872C5.52409 21.3982 5.48701 21.4072 5.44962 21.4142L3.27598 21.9426C2.92039 22.029 2.54546 21.9238 2.28669 21.6651C2.02793 21.4063 1.92275 21.0314 2.00919 20.6758L3.43548 14.8079C3.48093 14.6209 3.57693 14.4501 3.71298 14.314L15.7997 2.22743ZM5.58263 19.2233L8.36237 18.5475L20.2411 6.66895C21.0585 5.85148 21.0585 4.52804 20.2411 3.71057C19.4236 2.89311 18.1003 2.89311 17.2828 3.71057L5.40413 15.5891L4.72946 18.3648L5.58263 19.2233Z",
    fill: "#B2B5BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0639 5.09686C16.6549 4.6867 15.9909 4.68573 15.5807 5.09469C15.1706 5.50365 15.1696 6.16767 15.5786 6.57783L18.6843 9.69261C19.0932 10.1028 19.7572 10.1037 20.1674 9.69478C20.5775 9.28582 20.5785 8.6218 20.1696 8.21164L17.0639 5.09686Z",
    fill: "#B2B5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.873 19.8747C10.2938 19.8747 9.82422 20.3442 9.82422 20.9234C9.82422 21.5026 10.2938 21.9722 10.873 21.9722H21.9057C22.4849 21.9722 22.9544 21.5026 22.9544 20.9234C22.9544 20.3442 22.4849 19.8747 21.9057 19.8747H10.873Z",
    fill: "#B2B5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.de2b109e0150f9a13be3ea4bc2e41056.svg";
export { ForwardRef as ReactComponent };